/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_Point_1_LabelInputs */

const en_visa_l1_point_1_label = /** @type {(inputs: Visa_L1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employee Role Analysis`)
};

const pt_visa_l1_point_1_label = /** @type {(inputs: Visa_L1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise da Função do Funcionário`)
};

const es_visa_l1_point_1_label = /** @type {(inputs: Visa_L1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis del Cargo del Empleado`)
};

/**
* | output |
* | --- |
* | "Employee Role Analysis" |
*
* @param {Visa_L1_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_point_1_label = /** @type {((inputs?: Visa_L1_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_point_1_label(inputs)
	if (locale === "es") return es_visa_l1_point_1_label(inputs)
	return en_visa_l1_point_1_label(inputs)
});